import {Environment} from '../reducers/environmentReducer';

/**
 * If the environment language is English or the key is not found,
 * the key is returned. Otherwise, the key's translation
 * in the environment language is returned.
 */
export function getLocaleText(key: string): string {
	const translatedModalTerms = Environment.translated_modal_terms();

	// eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
	return translatedModalTerms?.[key] || key;
}
